import React from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { CircularProgress, Box } from '@material-ui/core';
import TriggerList from '../../components/EmailPlatform/TriggerList';
import { withSnackbar } from 'notistack';

const GET_EMAIL_TRIGGERS = gql`
  query GetEmailTriggers {
    email_triggers {
      id
      name
      event_type
      action_type
      active
      created_at
      email_template {
        id
        name
      }
      sequence {
        id
        name
      }
    }
  }
`;

const UPDATE_TRIGGER_ACTIVE = gql`
  mutation UpdateEmailTrigger($id: ID!, $active: Boolean!) {
    updateEmailTrigger(id: $id, active: $active) {
      emailTrigger {
        id
        active
      }
      errors
    }
  }
`;

const DELETE_TRIGGER = gql`
  mutation DeleteEmailTrigger($id: ID!) {
    deleteEmailTrigger(id: $id) {
      success
      errors
    }
  }
`;

class TriggerListContainer extends React.Component {
  handleToggleActive = (updateTrigger, refetch) => (triggerId, newActiveState) => {
    updateTrigger({
      variables: {
        id: triggerId,
        active: newActiveState,
      },
    })
      .then(({ data }) => {
        if (data.updateEmailTrigger.errors && data.updateEmailTrigger.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.updateEmailTrigger.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar(
            newActiveState ? 'Trigger activated' : 'Trigger deactivated',
            { variant: 'success' }
          );
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  handleDelete = (deleteTrigger, refetch) => (triggerId) => {
    deleteTrigger({
      variables: { id: triggerId },
    })
      .then(({ data }) => {
        if (data.deleteEmailTrigger.errors && data.deleteEmailTrigger.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.deleteEmailTrigger.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar('Trigger deleted successfully', { variant: 'success' });
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  render() {
    return (
      <Query query={GET_EMAIL_TRIGGERS}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
              </Box>
            );
          }

          if (error) {
            return <div>Error loading triggers: {error.message}</div>;
          }

          // Map snake_case GraphQL fields to camelCase for component compatibility.
          const triggers = (data.email_triggers || []).map(trigger => ({
            ...trigger,
            eventType:     trigger.event_type,
            actionType:    trigger.action_type,
            createdAt:     trigger.created_at,
            emailTemplate: trigger.email_template,
            emailSequence: trigger.sequence,
          }));

          return (
            <>
              <Mutation mutation={UPDATE_TRIGGER_ACTIVE}>
                {(updateTrigger) => (
                  <Mutation mutation={DELETE_TRIGGER}>
                    {(deleteTrigger) => (
                      <TriggerList
                        triggers={triggers}
                        onToggleActive={this.handleToggleActive(updateTrigger, refetch)}
                        onDelete={this.handleDelete(deleteTrigger, refetch)}
                        onRefresh={refetch}
                      />
                    )}
                  </Mutation>
                )}
              </Mutation>
            </>
          );
        }}
      </Query>
    );
  }
}

export default withSnackbar(TriggerListContainer);

